module.exports = __webpack_public_path__ + "media/images/logo/sns/facebook-cb13ed08ff14aff968a1a04501320f7d.png";